import React from "react";
import styled from "styled-components";
import { SurveySegmentation, SurveyTheme, rng } from "../../../amorg-common";
import { Button, ButtonProps } from "../../../designSystem/button/Button";
import { ButtonRow } from "../../../designSystem/button/ButtonRow";

type TemplateData = {
    id: string,
    themes: SurveyTheme[],
    segmentations: SurveySegmentation[],
    description: string;
};

type TemplateButtonProps = Omit<ButtonProps, 'onClick'> &
{ onClick: (templateId: string) => void; };

type SurveyTemplateListProps = {
    templates: TemplateData[],
    buttons?: TemplateButtonProps[];
};
export function SurveyTemplateList (props: SurveyTemplateListProps): JSX.Element
{
    const [detailedTemplateIds, setDetailedTemplatedIds] = React.useState<string[]>([]);

    return (
        <Table>
            <thead>
                <tr>
                    <th>Beskrivelse</th>
                    <th>Temaer</th>
                    <th>Spørgsmål</th>
                    <th>Indikatorer</th>
                    <th>Segmenteringer</th>
                    <th></th>
                </tr>
            </thead>
            {props.templates.map(t =>
            {
                const questions = t.themes.flatMap(t => t.questions);
                const indicators = rng.getUniqueStrings(questions.flatMap(q => q.indicators));
                const unfolded = detailedTemplateIds.find(id => id === t.id);
                return (
                    <tbody key={t.id}>
                        <tr>
                            <td>{t.description}</td>
                            <td>{t.themes.length}</td>
                            <td>{questions.length}</td>
                            <td>{indicators.length}</td>
                            <td>{t.segmentations.length}</td>
                            <td>
                                <Button variant='text' text={unfolded ? "Skjul" : "Vis"} icon={unfolded ? 'arrows_chevron_chevronUp' : 'arrows_chevron_chevronDown'}
                                    onClick={() =>
                                    {
                                        unfolded
                                            ? setDetailedTemplatedIds(detailedTemplateIds.filter(id => id !== t.id))
                                            : setDetailedTemplatedIds([...detailedTemplateIds, t.id]);
                                    }}
                                />
                            </td>
                        </tr>
                        {unfolded &&
                            <tr>
                                <td colSpan={6}>
                                    {props.buttons && props.buttons.length > 0 &&
                                        <OneCellRow>
                                            <ButtonRow variant="right-aligned" marginTop={5}>
                                                {props.buttons.map((val, index) =>
                                                    <Button key={index} {...val} onClick={() => val.onClick(t.id)} />
                                                )}
                                            </ButtonRow>
                                        </OneCellRow>
                                    }
                                    <ThreeCellRow>
                                        <Cell1>
                                            Temaer<br />
                                            {t.themes.map(theme =>
                                                <Pill key={theme.name}>{`${theme.name} (${theme.questions.length})`}</Pill>
                                            )}
                                        </Cell1>
                                        <Cell2>
                                            Indikatorer<br />
                                            {indicators.map(i => <Pill key={i}>{i}</Pill>)}
                                        </Cell2>
                                        <Cell3>
                                            Segmenteringer<br />
                                            {t.segmentations.map(s => <Pill key={s.name}>{s.name}</Pill>)}
                                        </Cell3>
                                    </ThreeCellRow>
                                </td>
                            </tr>
                        }
                    </tbody>
                );
            })}
        </Table>
    );
}

const Table = styled.table`
    width:100%;
    tr th {
        font-size: 12px;
        width:100px;
    }
    tr th:first-child{ 
        width:auto;
        text-align: left;
    }
    tr td{
        text-align: center;
    }
    tr td:first-child{ 
        text-align: left;
    }
`;

const Header1 = styled.div`
    flex:2;
`;
const Header2 = styled.div`
    flex:1;
`;
const Header3 = styled.div`
    flex:1;
`;

const ThreeCellRow = styled.div`
    display: flex;
    margin-top: 10px;
`;
const Cell1 = styled(Header1)`
`;
const Cell2 = styled(Header2)`
`;
const Cell3 = styled(Header3)`
`;
const OneCellRow = styled.div`
    font-size: 14px;
    padding:8px;
`;

const Pill = styled.div`
    display:inline-block;
    padding:3px;
    margin:5px;
    border-radius: 4px;
    border: 1px solid rgba(128,128,128,1);
    font-size: 14px;
`;